//
// Branding por parceiro (white label)
//
// Logo e título do card de autenticação são definidos aqui e exportados
// para uso nas páginas públicas: Login, ResetPassword, JoinGroup.
//

const PARTNER_LOGOS = {
  DEFAULT: require('@/assets/logo-white.png'),
  HUGOL: require('@/assets/logo-hugol.png'),
  RC: require('@/assets/logo-rc.png'),
  HALLAN: require('@/assets/logo-hallan.png'),
  PORTALTELEMEDICINA: require('@/assets/logo-portaltelemedicina.png'),
  PORTALCONSULTAS: require('@/assets/logo-portalconsultas.png'),
}
const logo = PARTNER_LOGOS[process.env.VUE_APP_PARTNER] || PARTNER_LOGOS.DEFAULT

// Título opcional que substitui a logo no card de autenticação.
// Use '\n' para quebra de linha.
const PARTNER_TITLES = {
  PORTALCONSULTAS: 'Agendamento\nde Consultas',
}
const authTitle = PARTNER_TITLES[process.env.VUE_APP_PARTNER] || null

export { logo, authTitle, PARTNER_LOGOS, PARTNER_TITLES }
